module.exports = __webpack_public_path__ + "img/Jordan.5c6b019f.svg";